import { ModifierKeys } from './useKeyPress.constants'

export interface UseKeyPressProps {
  key: string
  ref?: Node
  modifier?: ModifierKeys
  preventDefault?: boolean
  onKeyPress: (event: KeyboardEvent) => any
}
